import type { IxcCorpactionsCaadminV1PaymentKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const CORPACT_CA_ADMIN_PAYMENT_BASE_PATH = getResolvedPath('/clearing/operations/ca/payment');

export const getCorpactCaAdminPaymentPath: EntityPathBuilder<IxcCorpactionsCaadminV1PaymentKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return CORPACT_CA_ADMIN_PAYMENT_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.paymentId) {
        return undefined;
      }

      return getResolvedPath(`${CORPACT_CA_ADMIN_PAYMENT_BASE_PATH}/$paymentId`, context.keys);
    }
  }
};

export function getCorpactCaAdminPaymentDetailPath(paymentId: string | undefined) {
  if (!paymentId) {
    return undefined;
  }

  return getCorpactCaAdminPaymentPath({ kind: 'detail', keys: { paymentId } });
}
